// Přepínač zobrazení hesla (issue #17, screens/07-prihlaseni.md §„Heslo toggle").
//
// Jeden markup, dvě podoby (řeší CSS v _auth.scss):
//   desktop — ikona oka 34 px uvnitř pole vpravo (`bs-i-eye` / `bs-i-eye-off`)
//   mobil   — textový přepínač „Zobrazit / Skrýt" s hit-areou 44 px (m07 §5)
//
// Sdílené: použij všude, kde je pole s heslem (registrace, změna hesla v klientské
// sekci, pokladna). Idempotentní přes `data-bs-pwtoggle`.

import { icon } from './icon.js';
import L from '../locale/cs/passwordToggle.js';

const LABEL_SHOW = L.show;
const LABEL_HIDE = L.hide;
const A11Y_SHOW = L.a11yShow;
const A11Y_HIDE = L.a11yHide;

// input = pole typu password, host = obal, do kterého se tlačítko vloží
// (musí být `position: relative`; typicky `.bs-auth__ic`).
export function attachPasswordToggle(input, host) {
  if (!input || input.dataset.bsPwtoggle) return null;
  const parent = host || input.parentElement;
  if (!parent) return null;
  input.dataset.bsPwtoggle = '1';

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'bs-pwtoggle';
  btn.setAttribute('aria-pressed', 'false');
  btn.setAttribute('aria-label', A11Y_SHOW);
  btn.appendChild(icon('eye', 'bs-pwtoggle__eye'));
  btn.appendChild(icon('eye-off', 'bs-pwtoggle__eye-off'));

  const label = document.createElement('span');
  label.className = 'bs-pwtoggle__txt';
  label.textContent = LABEL_SHOW;
  btn.appendChild(label);

  btn.addEventListener('click', function () {
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    btn.classList.toggle('is-on', show);
    btn.setAttribute('aria-pressed', show ? 'true' : 'false');
    btn.setAttribute('aria-label', show ? A11Y_HIDE : A11Y_SHOW);
    label.textContent = show ? LABEL_HIDE : LABEL_SHOW;
  });

  parent.appendChild(btn);
  return btn;
}
